import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class CountryRoutingGuard implements CanActivate {

    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const currentCountry = localStorage.getItem('country');
        const currentPath = route.routeConfig?.path;

        // Get the full URL path to check for nested routes
        const fullPath = route.url.map(segment => segment.path).join('/');

        // Define routes that need country-based redirection
        const interRegionalRoutes = ['inter-regional', 'inter-regional-payment-success', 'inter-regional-detail'];
        const interStateRoutes = ['inter-state', 'inter-state-payment-success', 'inter-state-detail'];

        // Check for inter-regional routes (both direct and nested)
        if (interRegionalRoutes.includes(currentPath) || fullPath.includes('inter-regional-detail')) {
            // Nigeria users should be redirected to inter-state equivalent
            if (currentCountry === 'Nigeria') {
                if (currentPath === 'inter-regional') {
                    this.router.navigate(['/inter-state']);
                } else if (currentPath === 'inter-regional-payment-success') {
                    this.router.navigate(['/inter-state-payment-success']);
                } else if (currentPath === 'inter-regional-detail' || fullPath.includes('inter-regional-detail')) {
                    // Get the order ID from the route parameters
                    const orderId = route.params['id'];
                    this.router.navigate(['/orders/inter-state-detail/', orderId]);
                }
                return false;
            }
        }

        // Check for inter-state routes (both direct and nested)
        if (interStateRoutes.includes(currentPath) || fullPath.includes('inter-state-detail')) {
            // Ghana users should be redirected to inter-regional equivalent
            if (currentCountry === 'Ghana') {
                if (currentPath === 'inter-state') {
                    this.router.navigate(['/inter-regional']);
                } else if (currentPath === 'inter-state-payment-success') {
                    this.router.navigate(['/inter-regional-payment-success']);
                } else if (currentPath === 'inter-state-detail' || fullPath.includes('inter-state-detail')) {
                    // Get the order ID from the route parameters
                    const orderId = route.params['id'];
                    this.router.navigate(['/orders/inter-regional-detail/', orderId]);
                }
                return false;
            }
        }

        return true;
    }
}
